import React from "react";
import {Card, CloseButton, Dropdown} from "react-bootstrap";
import {FaCheck, FaCog, FaEnvelope, FaInfoCircle, FaPhone, FaWrench} from 'react-icons/fa';
import {useInstallationServiceQuery} from "../../../hooks/useInstallationServiceQuery";

export const InstallationService = () => {
    const {
        model: {isOffered},
        dropDownState: {open, toggle},
        contactGroupModel: {
            render,
            email,
            phone
        }
    } = useInstallationServiceQuery();

    // If the installation service is not offered, don't render anything
    if (!isOffered) return <></>;

    return (
        <Card body className=" my-3">
            <div id="installation-services" className="d-flex align-items-center">
                <div className="mx-3">
                    <span className="position-relative">
                        <FaCog size={42}
                               style={{opacity: 0.3}}
                               aria-hidden="true"
                               className="text-purple position-absolute top-50 start-50 translate-middle"/>
                        <FaWrench aria-hidden="true" size={32}
                                  className="text-purple position-absolute top-50 start-50 translate-middle"/>
                    </span>
                </div>
                <div className="ms-3">
                    <strong className="text-purple"
                            style={{fontSize: '1rem'}}>
                        Installation Service Available
                    </strong>
                    <Dropdown id="installation-info-dropdown"
                              show={open}
                              onToggle={toggle}
                    >
                        <Dropdown.Toggle id="installation-info"
                                        aria-label="Learn More about Installation Services"
                                         variant="link"
                                         className="p-0">
                            Learn more<FaInfoCircle className="ms-1" aria-hidden="true"/>
                        </Dropdown.Toggle>
                        <Dropdown.Menu id="installation-info-dropdown" className="p-3" style={{width: '350px'}}>
                            <div className="d-flex justify-content-between align-items center border-bottom pb-3">
                                <div>
                                    <strong className="fs-5">Leave it to the Professionals</strong>
                                    <span className="text-muted d-block">Commercial Installation Service</span>
                                </div>
                                <CloseButton className="fs-5" onClick={toggle}/>
                            </div>
                            <div className="pt-3">
                                <p>
                                    Call or email our contact center today to set up your initial consultation:
                                </p>
                                {render && (
                                    <ul className="fa-ul ms-0">
                                        {phone && (
                                            <li>
                                                <a href={`tel:${phone}`} tabIndex={0} role="link" aria-label="telephone number link">
                                                    <FaPhone className="me-1" aria-hidden="true"/>
                                                    {phone}
                                                </a>
                                            </li>
                                        )}
                                        {email && (
                                            <li>
                                                <a href={`mailto:${email}`} tabIndex={0} role="link" aria-label="email link">
                                                    <FaEnvelope className="me-1" aria-hidden="true"/>
                                                    {email}
                                                </a>
                                            </li>
                                        )}
                                    </ul>
                                )}
                                <ul className="fa-ul  ms-0">
                                    <li><FaCheck className="text-purple me-1" aria-hidden="true"/>
                                        Commitment-free consultation
                                    </li>
                                    <li><FaCheck className="text-purple me-1" aria-hidden="true"/>
                                        Average install 14 days
                                    </li>
                                    <li><FaCheck className="text-purple me-1" aria-hidden="true"/>
                                        Nationwide service (US-Only, Alaska Excluded)
                                    </li>
                                </ul>
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>
        </Card>
    )
}